<template>
  <div class="container-fluid h-100">

    <!-- Imagen principal de havoblog -->
    <div class="content-havoblog" id="content-havoblog-id" alt="Havoblog"></div>

    <!-- Imagen de información general -->
    <div class="content-img_1" id="content-img-id_1" alt="Bienvenido al blog motero"></div>

    <!-- Listado de havoblogs -->
    <div class="content-img_2" id="content-img-id_2" alt="Fondo listado de blogs">
      <div class="title">
        <h1>Las Últimas Tendencias en Tecnología para Motocicletas: ¿Qué Debes Saber?</h1>
      </div>
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
      >
        <div class="col-12 col-md-12 col-lg-8 col-xl-8 col-sm-12">
          <template v-if="loading.history">
            <div
              class="spinner-border text-danger mt-5"
              style="width:4rem; height:4rem; margin-bottom:30px;"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </template>

          <!-- Listado de blogs -->
          <template v-else>
            <div class="row">
              <div v-if="items.length <= 0" class="not_blogs">
                <h3>No hay Havoblogs disponibles</h3>
              </div>
              <div
                class="pt-4 col-xs-12 col-sm-6 col-md-4 col-xl-2 blogs"
                v-for="data in items.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :key="data.id"
              >
                <div class="card-blogs">
                  <div class="contenedor">
                    <img
                      :src="data.img"
                      class="img-prod"
                      @click="irBlog(data)"
                      :alt="data.name"
                    />
                  </div>
                </div>
                <!-- Título y subtítulo del blog -->
                <div>
                  <h2 class="title_blog">
                    {{ data.title != null ? data.title : '' }}
                  </h2>
                  <h3 class="subtitle_blog">
                    {{ data.subtitle != null ? data.subtitle : '' }}
                  </h3>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div style="margin:25px 5px 5px 5px;" class="d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" :class="{disabled: currentPage === 1}">
            <a class="previous page-link" href="#" @click.prevent="prevPage()">
              <
            </a>
          </li>
          <li class="page-item" v-for="page in pages" :key="page" :class="{active: currentPage === page}">
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>
          <li class="page-item" :class="{disabled: currentPage === totalPages}">
            <a class="next page-link" href="#" @click.prevent="nextPage()">
              >
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal para ir a las redes sociales de HavolineColombia -->
    <div
      class="modal fade"
      id="modalRRSS"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div style="min-width:45%;" class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modalRRSS" alt="fondo modal redes">
          <div class="content_btn_close">
            <img
              src="../../../assets/iconsRRSS/logo_close.png"
              width="20"
              title="cerrar popup"
              alt="cerrar popup"
              @click="closedModal()"
            />
          </div>
          <div style="margin-top:20px;" class="mr-md-4">
            <img
              src="../../../assets/iconsRRSS/logo_havoline.png"
              width="150"
              title="logo havoline"
              alt="logo havoline"
            />
          </div>
          <div class="modal_content_rrss">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color:#6c757d; margin:auto;"
            >
              <span class="text_white">Síguenos en nuestras redes </span><span class="text_yellow">para que no <br> te pierdas de todo nuestro contenido.</span>
            </h5>
          </div>
          <div style="margin:auto;" class="modal_footer_rrs">
            <div class="row pt-4 pb-3 d-flex justify-content-center">
              <div class="">
                <a href="https://www.instagram.com/havolinecolombia" target="_blank" rel="noopener noreferrer">
                  <img 
                    height="40" 
                    width="40" 
                    src="../../../assets/iconsRRSS/logo_instagram.png"
                    title="Instagram HavolineColombia"
                    alt="Instagram HavolineColombia"
                  />
                </a>
                <a href="https://www.facebook.com/HavolineColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../../assets/iconsRRSS/logo_facebook.png"
                    title="Facebook HavolineColombia"
                    alt="Facebook HavolineColombia"
                  />
                </a>
                <a href="https://www.youtube.com/ChevronColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../../assets/iconsRRSS/logo_youtube.png"
                    title="YouTube HavolineColombia"
                    alt="YouTube HavolineColombia"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
  
<script>
  import $ from "jquery";
  //import * as XLSX from 'xlsx';
  import axios from 'axios';
  
  export default {
    data() {
      return {
        searchN: '',
        loading: {
          history: false,
        },
        items: [],
        
        // Paginación
        currentPage: 1,
        pageSize: 6,
        totalDatos: 0,
        totalPages: 0,
        paginatedData: [],
        paginationVisible: true,
      };
    },
    computed: {
      pages() {
        const pages = [];
        const limit = this.totalPages > 5 ? 5 : this.totalPages;
        let start = this.currentPage - 2;
        if (start <= 0) start = 1;
        let end = start + limit - 1;
        if (end > this.totalPages) {
          end = this.totalPages;
          start = end - limit + 1;
          if (start <= 0) start = 1;
        }
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        return pages;
      },
    },
    methods: {
      listAllHavoblogs(){
        this.items = [];
        this.loading.history = true;
        const data = {
          filter: this.searchN.length > 0 ? 1 : 0,
          textFilter: this.searchN
        }
        axios
        .post("havoblog/listBlogs", data)
        .then(res => {
          if (res.data.cod == 0) {
            res.data.data.map((item) => {
              if(item.status_id == 1){
                this.items.push(item);
                this.totalDatos = this.items.length;
                this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
                this.paginated();
              }
            })
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      irBlog(item){
        localStorage.setItem('blogId', item.id);
        var blogName = item.name.replace(/ /g, "-");
        localStorage.setItem('nameSlug', blogName);
        this.$router.push({ name: "descriptionHavoblog", params: { blogId: item.id, nameSlug: blogName } });
      },
      closedModal(){
        $("#modalRRSS").modal("hide");
      },

      // Paginación
      paginated() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.paginatedData = this.items.slice(start, end);
      },
      changePage(page) {
        this.currentPage = page;
        this.paginated();
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.paginated();
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.paginated();
        }
      },
      changeSize(size) {
        this.pageSize = size;
        this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
        this.currentPage = 1;
        this.paginated();
      },
      // Fin paginación
    },
    mounted() {
      this.listAllHavoblogs();
      if (!sessionStorage.getItem('modalRRSS3')){
        $("#modalRRSS").modal("show");
        sessionStorage.setItem('modalRRSS3', 1);
      }
    },
  };
</script>
  
<style scoped>
.container-fluid{
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
#content-havoblog-id {
  padding-top: 20%;
  padding-bottom: 20%;
  /* height: 100vh; */
}
.content-havoblog{
  margin-top: 55px;
  background-size: cover;
  background-image: url("../../../assets/img/fondo_superior.jpg");
  background-position: center center;
  background-color: "#171717";
}
#content-img-id_1 {
  padding-top: 8%;
  padding-bottom: 8%;
  /* height: 250px; */
}
.content-img_1{
  background-size: cover;
  background-image: url("../../../assets/img/barra_info.jpg");  
}
#content-img-id_2 {
  min-width: 100%;
}
.content-img_2{
  padding-top: 25px;
  background-size: cover;
  background-image: url("../../../assets/img/fondo_list_blogs_v2.jpg");  
}
.title{
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 40px 40px 0px 0px;
  height: auto;
  max-width: 80%;
  margin: auto;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  padding: 20px 30px;
}
.title h1{
  font-size: 28px;
  margin: auto;
}
.card-blogs{
  background-color: white;
  border-radius: 30px 0px 30px 30px;
  cursor: pointer;
}
.img-prod{
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 30px 0px 30px 30px;
  padding: 5px;
}
.title_blog{
  font-size: 20px;
  color: yellow;
  text-align: left;
  padding: 10px 10px 10px 10px;
  /* font-family: "GothamBoldItalic"; */
}
.subtitle_blog{
  font-size: 15px;
  background-color: black;
  border-radius: 10px 20px 10px 10px;
  text-align: left;
  padding: 10px 10px 10px 10px;
  color: white;
  /* font-family: "GothamBookItalic"; */
}
.text-p{
  color: black;
}
.not_blogs{
  margin: auto;
  padding: 20px;
}
.previous{
  color:#0056b3 !important;
  border-radius: 20px 0px 0px 20px !important;
  margin-right: 5px;
}
.next{
  color:#0056b3 !important;
  border-radius: 0px 20px 20px 0px !important;
}
.page-link {
  border-color: none;
  margin-right: 5px;
}
.page-item.active .page-link {
  border-style: none;
  background-color: #dc3545;
}
.page-item.disabled .page-link {
  color: #dc3545;
}

/* Movil */
@media (max-width: 500px) {
  .title{
    height: auto;
    max-width: 90%;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    padding: 10px 15px;
    border-radius: 40px;
  }
  .title h1{
    font-size: 16px;
  }
  .title_blog, .subtitle_blog{
    text-align: center;
  }
}
.modalRRSS{
  background-image: url('../../../assets/iconsRRSS/fondo_modalrrss.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.modal_content_rrss, .modal_footer_rrs{
  padding: 20px 15px 30px 15px;
}
.content_btn_close{
  margin: 20px 25px auto auto;
  cursor: pointer;
}
.text_white{
  color: white;
  font-weight: bold;
}
.text_yellow{
  color: #ffce00;
  font-weight: bold;
}
</style>
  